import { DynamicDbDisplayValueSearchEvent, TableRowCreationEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutEdiNotify } from "./autogen/AutogenLayoutEdiNotify";
import { TenderProfile } from "./TenderProfile";
import { GenericProfile } from "./GenericProfile";
import { BillingProfile } from "./BillingProfile";
import { StatusProfile } from "./StatusProfile";
import { EdiRemitAdvProf } from "./EdiRemitAdvProf";

export class EdiNotify extends AutogenLayoutEdiNotify {

    /** This is an event handler for the onRowCreate event of tableEdiNotify. */
    tableEdiNotifyOnRowCreate(event: TableRowCreationEvent) {
        console.log("Row create event triggered");
        const row = event.getTableRow();

        // Only execute this logic for truly new rows (when quick add row button is clicked)
        if (this.owner && this.owner.mainDataSource && this.owner.mainDataSource.activeRow && row.data._appending) {
            const parentRow = this.owner.mainDataSource.activeRow;
            const newRow = event.getTableRow().data;

            // Set the required fields from parent
            newRow.set("partner_id", parentRow.get("partner_id"));
            newRow.set("alt_partner_id", parentRow.get("alt_partner_id"));
            newRow.set("direction", parentRow.get("direction"));
            newRow.set("version", parentRow.get("version"));

            // Set transaction_set to 'T'
            newRow.set("transaction_type", this.getTransactionType());
        }

        // Also try to set it directly on the textbox component using correct ID
        setTimeout(() => {
            const textboxNotifyMethod = row.findComponentById("textboxtNotifyMethod") as Textbox;
            if (textboxNotifyMethod) {
                console.log("Found textbox, setting to Email");
                // textboxNotifyMethod.text = "Email";
                textboxNotifyMethod.setSelectedItemFromValue("E");
            } else {
                console.log("textboxtNotifyMethod not found");
            }
            const textboxNotifyMethodIn = row.findComponentById("textboxtNotifyMethodIn") as Textbox;
            if (textboxNotifyMethodIn) {
                console.log("Found textbox, setting to Email");
                // textboxNotifyMethodIn.text = "Email";
                textboxNotifyMethodIn.setSelectedItemFromValue("E");
            } else {
                console.log("textboxtNotifyMethodIn not found");
            }

        }, 50);
    }

    textboxNotifyTypeBeforeDynamicDbDisplayValueSearch(event: DynamicDbDisplayValueSearchEvent) {
        const transactionType = this.getTransactionType();
        const formatType = "A";
        const direction = "I";

        event.addAddlValue("transaction_type", transactionType);
        event.addAddlValue("format_type", formatType);
        event.addAddlValue("direction", direction);
    }

    /** This is an event handler for the beforeDynamicDbDisplayValueSearch event of textboxNotifyTypeOutbound. */
    textboxNotifyTypeOutboundBeforeDynamicDbDisplayValueSearch(event: DynamicDbDisplayValueSearchEvent) {
        const transactionType = this.getTransactionType();
        const formatType = "A";//A for X12
        const direction = "O";

        event.addAddlValue("transaction_type", transactionType);
        event.addAddlValue("format_type", formatType);
        event.addAddlValue("direction", direction);
    }

    getTransactionType(): string {
        if (this.parent?.owner instanceof TenderProfile) {
            return "T";
        } else if (this.parent?.owner instanceof BillingProfile) {
            return "I";
        } else if (this.parent?.owner instanceof GenericProfile) {
            return "A";
        } else if (this.parent?.owner instanceof StatusProfile) {
            return "S";
        } else if(this.parent?.owner instanceof EdiRemitAdvProf){
            return "A"; // Default or unknown profile type
        } else{
            return "Z";
        }
    }
}
